// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

// 🏠 URL base para desarrollo
const BASE_URL = "https://preprodsga.iessuruguay.com/backend";

// 🔧 Función helper para concatenar URLs
const createApi = (baseUrl: string) => ({
  // 🌐 URL base (para casos especiales)
  url: baseUrl,

  // 📋 APIs principales
  alumnos: `${baseUrl}/alumnos.php`,
  ciudades: `${baseUrl}/ciudades.php`,
  contratos: `${baseUrl}/contratos.php`,
  cursos: `${baseUrl}/cursos.php`,
  departamentos: `${baseUrl}/departamentos.php`,
  facturas: `${baseUrl}/facturas.php`,
  facultades: `${baseUrl}/facultades.php`,
  grupos: `${baseUrl}/grupos.php`,
  grupos_all: `${baseUrl}/grupos_all.php`,
  images: `${baseUrl}/images`,
  login: `${baseUrl}/login.php`,
  mail: `${baseUrl}/send_mail.php`,
  mailRecordatorio: `${baseUrl}/send_mail_recorder.php`,
  mailVencimiento: `${baseUrl}/send_mail_vencimiento.php`,
  paises: `${baseUrl}/paises.php`,
  personas: `${baseUrl}/personas.php`,
  recibos: `${baseUrl}/recibo_print.php`,
  reciboImprimir: `${baseUrl}/recibo_imprimir.php`,
  reportes: `${baseUrl}/reporte_print.php`,
  tipos_persona: `${baseUrl}/tipos_persona.php`,
  utils: `${baseUrl}/utils.php`,
  usuarios: `${baseUrl}/usuarios.php`,
  auditoria: `${baseUrl}/auditoria.php`,
  verificar_token: `${baseUrl}/verify_token.php`,

  // ⚠️ URLs que no apuntan a rutas existentes
  clientes: `${baseUrl}/clientes.php`,
  clientes_direcciones: `${baseUrl}/clientes_direcciones.php`,
  datos: `${baseUrl}/datos_extra.php`,
  datos_clientes: `${baseUrl}/datos_extra_clientes.php`,
  datos_extra_direcciones: `${baseUrl}/datos_extra_direccion.php`,
  datos_extra_servicios: `${baseUrl}/datos_extra_servicios.php`,
  datos_extra_visitas: `${baseUrl}/datos_extra_visitas.php`,
  direcciones: `${baseUrl}/direcciones.php`,
  direcciones_image: `${baseUrl}/direcciones_image.php`,
  medidas: `${baseUrl}/medidas.php`,
  permisos: `${baseUrl}/permisos.php`,
  recuperar: `${baseUrl}/recuperar.php`,
  roles: `${baseUrl}/roles.php`,
  servicios: `${baseUrl}/servicios.php`,
  servicios_tot: `${baseUrl}/services_tot.php`,
  tipo_clientes: `${baseUrl}/tipo_clientes.php`,
  visitas: `${baseUrl}/visitas.php`,
  zonas_ciudades_departamentos: `${baseUrl}/zonas_ciudades_departamentos.php`,
});

export const environment = {
  production: false,
  // URLs para desarrollo local
  api: createApi(BASE_URL),
  data_options: {
    responsive: true,
    language: {
      processing: "Procesando...",
      lengthMenu: "Mostrar _MENU_ registros",
      zeroRecords: "No se encontraron resultados",
      emptyTable: "Ningún dato disponible en esta tabla",
      info: "Mostrando registros del _START_ al _END_ de un total de _TOTAL_ registros",
      infoEmpty: "Mostrando registros del 0 al 0 de un total de 0 registros",
      infoFiltered: "(filtrado de un total de _MAX_ registros)",
      infoPostFix: "",
      search: "Buscar:",
      url: "",
      loadingRecords: "Cargando...",
      paginate: {
        first: "Primero",
        last: "Último",
        next: "Siguiente",
        previous: "Anterior",
      },
      aria: {
        sortAscending: ": Activar para ordenar la columna de manera ascendente",
        sortDescending:
          ": Activar para ordenar la columna de manera descendente",
      },
    },
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
